/**
 * ReportHeader.js — TLP banner, title, metadata, export controls
 */
import React from "react";
import { TLP_OPTIONS, formatDate } from "../reportUtils";

export default function ReportHeader({ reportTitle, analyst, tlp, fileName, theme, onPrint, onHTML, onXML, onCSV }) {
  const tlpData  = TLP_OPTIONS.find(t => t.value === tlp);
  const tlpColor = tlpData?.color || theme.colors.textPrimary;
  const tlpBg    = tlpData?.bg    || "#F0F4FF";

  return (
    <div className="report-section" style={{ marginBottom: 24 }}>
      {/* TLP Banner */}
      <div style={{
        background: tlpBg, border: `2px solid ${tlpColor}`,
        borderRadius: 8, padding: "10px 20px", marginBottom: 16,
        textAlign: "center", fontFamily: "monospace",
        fontWeight: 900, fontSize: 13, letterSpacing: 3, color: tlpColor
      }}>
        {tlpData?.label}
      </div>

      {/* Report Header Card */}
      <div className="report-card" style={{
        background: theme.mode === "dark"
          ? "linear-gradient(135deg, #0C1628, #0A1535)"
          : `linear-gradient(135deg, ${theme.colors.card}, ${theme.colors.cardElevated})`,
        border: `1px solid ${theme.colors.accent}44`,
        borderRadius: 12, padding: "28px 32px",
        display: "flex", justifyContent: "space-between",
        alignItems: "flex-start", flexWrap: "wrap", gap: 16
      }}>
        <div>
          {/* Logo */}
          <div style={{ fontFamily: theme.fonts.display, fontSize: 24, fontWeight: 900, marginBottom: 8 }}>
            <span style={{ color: theme.colors.accent }}>NEX</span><span style={{ color: theme.colors.brandText }}>GEN</span>
            <span style={{ fontFamily: theme.fonts.mono, fontSize: 11, color: theme.colors.textMuted, marginLeft: 12, letterSpacing: 1 }}>
              CYBER INTELLIGENCE PLATFORM
            </span>
          </div>

          {/* Report Title */}
          <div style={{ fontFamily: theme.fonts.display, fontSize: 28, fontWeight: 900, color: theme.colors.accent, letterSpacing: 1, marginBottom: 12 }}>
            {reportTitle}
          </div>

          {/* Metadata grid */}
          <div style={{ display: "grid", gridTemplateColumns: "repeat(3, auto)", gap: "6px 32px" }}>
            {[
              { label: "ANALYST",   value: analyst },
              { label: "DATASET",   value: fileName },
              { label: "GENERATED", value: formatDate() },
              { label: "TLP",       value: tlp, color: tlpColor },
              { label: "PLATFORM",  value: "NexGen v3.0" },
              { label: "CONTACT",   value: "contact@hassaanalrifai.com" },
            ].map(({ label, value, color }) => (
              <div key={label}>
                <span style={{ fontFamily: "monospace", fontSize: 10, color: theme.colors.textMuted, letterSpacing: 1 }}>{label}: </span>
                <span style={{ fontFamily: "monospace", fontSize: 11, color: color || theme.colors.textSecondary, fontWeight: 700 }}>{value}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Export buttons — hidden on print */}
        <div className="no-print" style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          <button onClick={onPrint} style={btnStyle("#4F746C")}>🖨 Print / PDF</button>
          <button onClick={onHTML}  style={btnStyle("#00BCD4")}>⬇ Export HTML</button>
          <button onClick={onXML}   style={btnStyle("#BF8859")}>⬇ Export XML</button>
          <button onClick={onCSV}   style={btnStyle("#6D7961")}>⬇ Export CSV</button>
        </div>
      </div>
    </div>
  );
}

const btnStyle = (color) => ({
  padding: "8px 16px", background: `${color}18`,
  border: `1px solid ${color}44`, borderRadius: 6,
  color, fontFamily: "monospace", fontWeight: 700,
  fontSize: 11, letterSpacing: 1, cursor: "pointer", whiteSpace: "nowrap"
});
